"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var migrateToV1_1 = tslib_1.__importDefault(require("./migrations/migrateToV1"));
var constants_1 = require("./constants");
var migrations = {
    0: migrateToV1_1.default,
};
function migrateSettings(settings) {
    if (settings && settings.settingsVersion !== constants_1.SETTINGS_VERSION) {
        var version = settings.settingsVersion || 0;
        while (version < constants_1.SETTINGS_VERSION) {
            if (!migrations[version]) {
                console.error("There are now migration for version ".concat(version)); // tslint:disable-line:no-console
                return settings;
            }
            settings = migrations[version](settings);
            version = version + 1;
        }
    }
    return settings;
}
exports.default = migrateSettings;
//# sourceMappingURL=migrateSettings.js.map